import {
  FaLocationDot,
  FaPeopleGroup,
  FaMoneyBillTransfer,
} from "react-icons/fa6";
export const campInformation = {
  wintercampFAQ: [
    { type: "date", day: "20", month: "Dec", fullInfo: "December 20th, 2026" },
    { type: "date", day: "26", month: "Dec", fullInfo: "December 26th, 2026" },
    {
      type: "icon",
      icon: <FaLocationDot />,
      fullInfo: "Camp Cullen, Trinity, TX",
    },
    {
      type: "icon",
      icon: <FaPeopleGroup color="white" fontSize={"3rem"} />,
      fullInfo: "Children Grades 1 - 12",
    },
    {
      type: "icon",
      icon: <FaPeopleGroup />,
      fullInfo: "Children Grades 1 - 12",
    },
    {
      type: "icon",
      icon: <FaMoneyBillTransfer />,
      fullInfo: "$280 for first child $250 for every subsequent child after",
    },
  ],
  wintercamp: {
    id: "winter-camp",
    enabled: true,
    camp_title: "Winter camp 2026",
    theme: "Birth of the Khalsa",
    description:
      "A week of kirtan, gatka, divaan, Sikh history, sports and sangat in the pine woods of East Texas.",
    registration_link: "/register",
    informational_blobs: [
      { title: "Drop-off", data: "Sunday, December 20th" },
      { title: "Pickup", data: "Saturday, December 26th" },
      { title: "Where", data: "YMCA Camp Cullen, Trinity, TX" },
      { title: "Who", data: "Children in grades 1 through 12" },
      {
        title: "Fees",
        data: "$280 for the first child\n$250 for each additional child",
      },
    ],
  },
  retreat: {
    id: "retreat",
    enabled: false,
    camp_title: "RETREAT 2026",
    registration_information: "",
    registration_link: null,
    informational_blobs: [
      {
        title: "RETREAT START & DROPOFF",
        data: "Friday, September 1s",
      },
      {
        title: "RETREAT END & PICKUP",
        data: "Monday, September 4th",
      },
      {
        title: "WHERE",
        data: "CYJ Retreat Center, Woodcreek, TX",
      },
      {
        title: "WHO",
        data: "Rising college juniors and above",
      },
      {
        title: "CAMP FEES",
        data: "$250 for college students\n$300 for working professionals",
      },
      {
        title: "CONTACT",
        data: "texassikhretreat@gmail.com",
      },
    ],
  },
};

export const packingInformation = {
  General: [
    "Tennis shoes",
    "Water Bottle",
    "Bathroom slippers",
    "Bath Towel",
    "Medication",
    "Toiletries (toothbrush, toothpaste, hairbrush, bath soap,etc.)",
    "Head covering(s) for the weekend (dastaar, chuni, rumal)",
    "7 days worth of weather and camp-appropriate attire (pants, shirts, undergarments, socks, jackets, sweatshirts)",
    "2 Kurta/Chola/Suit(s) for kirtan darbar and gatka show",
    "Twin bedding (fitted sheets, pillow (in pillowcase), comforter)",
  ],
  Optional: ["Flashlight", "Sunscreen", "Umbrella", "Bug Spray"],
};
